var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnlinkBase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 9C5.34315 9 4 10.3431 4 12C4 13.6569 5.34315 15 7 15H8C8.55228 15 9 15.4477 9 16C9 16.5523 8.55228 17 8 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7H9C9.55228 7 10 7.44772 10 8C10 8.55228 9.55228 9 9 9H7Z",
    fill: "#141312"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 9C18.6569 9 20 10.3431 20 12C20 13.6569 18.6569 15 17 15H15C14.4477 15 14 15.4477 14 16C14 16.5523 14.4477 17 15 17H17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7H16.5C15.9477 7 15.5 7.44772 15.5 8C15.5 8.55228 15.9477 9 16.5 9H17Z",
    fill: "#141312"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2428 3.02985C14.7786 3.1638 15.1043 3.70673 14.9704 4.24253L10.9704 20.2425C10.8364 20.7783 10.2935 21.1041 9.7577 20.9701C9.22191 20.8362 8.89615 20.2933 9.03009 19.7575L13.0301 3.75746C13.164 3.22166 13.707 2.8959 14.2428 3.02985Z",
    fill: "#141312"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlinkBase);
export default __webpack_public_path__ + "static/media/unlink-base.6752e856956f93ba2f993acbd7f74f96.svg";
export { ForwardRef as ReactComponent };